module.exports = __webpack_public_path__ + "static/media/dmtd3.d8dad9e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dmtd3.jpg
// module id = 326
// module chunks = 0